// extracted by mini-css-extract-plugin
module.exports = {"container":"TagList_container_3U-d3"};